import s from "../productCardV3.module.css";
import {ritaIcon} from "../../../assets";
import {useUserContext} from "../../../contexts";

const ProductVendorBadge = (props) => {
    // Destructured props
    const {
        // formattedHref,
        tablePrice
    } = props;

    // Retrieves the flag to control the affiliation data customizations
    const [{}, {}, {}, generalData] = useUserContext();

    const {affiliationData} = generalData;

    // Prevents errors
    if (
        !tablePrice.tableCode ||
        !tablePrice.label
    ) {
        return null;
    }

    const discountLabel =
        affiliationData?.vendor !== "RITA" ? null : (
            <p
                // data-testid={`rita-product-card-badge-${formattedHref}`}
                className={"dark:text-black"}
            >
                Desconto Rita
            </p>
        );

    const iconSrc =
        affiliationData?.customizations?.icon ?
            `/media/${affiliationData?.customizations?.icon}` :
            ritaIcon;

    return (
        <div
            className={`${s.serviceType} font-museo dark:!bg-contrast-yellow flex gap-[0.5rem] text-[12px]`}
            // data-testid={`rita-product-card-badge-container-${formattedHref}`}
            style={{
                backgroundColor: tablePrice.color || "rgb(112, 107, 255)"
            }}
        >
            <img
                src={iconSrc}
                alt="rita icon"
                className={`w-[25px]`}
            />
            <div className="flex flex-col items-start">
                <p
                    // data-testid={`rita-product-card-badge-${formattedHref}`}
                    className={"dark:text-black font-semibold uppercase"}
                >
                    {tablePrice.label}
                </p>
                {discountLabel}
            </div>
        </div>
    )
}

export default ProductVendorBadge;
